import React, { useState } from 'react';
import { useAddSheetMutation } from '@/redux';
import { useAppFindFormik } from '@/components';
import { CreateSheetDto, ProjectDto } from '@/core';
import { SheetForm } from './SheetForm';
import { TableTypesEnum } from '../Projects.Constructor.Tables/hooks';
import { FormValueType } from './hooks';
import { filterTablesByType, validateMainTables } from './helpers';

const getInitialValue = (): FormValueType => ({
  name: '',
  tables: undefined,
  epics: undefined,
});

type PropsType = {
  projectData: ProjectDto;
};

export const ProjectsAddSheetForm = ({ projectData }: PropsType) => {
  const form = useAppFindFormik('add-sheet');
  const initialValue = getInitialValue();
  const [addSheet] = useAddSheetMutation();
  const [pickedTables, setPickedTables] = useState<string[] | undefined>(initialValue.tables);
  const [mainTableValidationError, setMainTableValidationError] = useState('');
  const mainTables = filterTablesByType(projectData, TableTypesEnum.Main, pickedTables);
  const summaryTables = filterTablesByType(projectData, TableTypesEnum.Summary, pickedTables);

  const clearForm = () => {
    form.current?.resetForm();
    setMainTableValidationError('');
    setPickedTables(initialValue.tables);
  };

  const handleSubmit = (sheetData: CreateSheetDto) => {
    const validationError = validateMainTables(sheetData.tables, projectData);

    if (validationError) {
      setMainTableValidationError(validationError);
      return;
    }

    addSheet({
      sheetData: {
        ...sheetData,
        tables: pickedTables?.map((tableId, index) => ({ tableId, sequence: index }))!,
      },
      projectId: projectData.id,
    })
      .unwrap()
      .then(() => clearForm());
  };

  const handlePickedTables = (tables: string[]) => {
    setPickedTables(tables);
    setMainTableValidationError('');
  };

  return (
    <SheetForm
      handleSubmit={handleSubmit}
      projectData={projectData}
      mainTableValidationError={mainTableValidationError}
      formUid="add-sheet"
      initialValue={initialValue}
      mainTables={mainTables}
      summaryTables={summaryTables}
      pickedTables={pickedTables}
      clearForm={clearForm}
      setPickedTables={handlePickedTables}
    />
  );
};
